import { Pipe, PipeTransform } from '@angular/core';

interface ICommonAdditionalTextOptions {
	additionalText?: string,
	showValue?: boolean,
	separator?: string,
}

export const COMMON_SPACE_SEPARATOR = ' ';

@Pipe({
	name: 'commonShowAdditionalText',
})
export class CommonShowAdditionalTextPipe implements PipeTransform {
	transform (value: string, options: ICommonAdditionalTextOptions = {}): string {
		const { additionalText, showValue, separator } = options;

		if (value) {
			if (showValue) {
				return value + (separator || COMMON_SPACE_SEPARATOR) + additionalText;
			} else {
                return value;
            }
		}
	}
}
